import { tracked } from '@glimmer/tracking';

import type { GeneralComponentClass } from 'webapp-types';

import InfolayerTypeDataExportComponent from 'webapp/components/infolayer/type-data-export';

import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase, { EXPIRE_ERROR } from 'webapp/models-custom/infolayer-item/base';
import { Type as GeneralType } from 'webapp/models-custom/infolayer-item/general';

export interface DataExportDeliveryLikeType {
	url?: string;
	name: string;
	fileSize?: string;
	type?: string;
	spaceAccessId: number;
	isError?: boolean;
	errorText?: string;
}

export interface ConstructorData extends BaseConstructorData {
	dataExportDelivery: DataExportDeliveryLikeType;
}

export default class InfolayerItemDataExport extends InfolayerItemBase {
	componentClass: GeneralComponentClass = InfolayerTypeDataExportComponent;

	@tracked status = GeneralType.LOADING;
	@tracked dataExportDelivery: DataExportDeliveryLikeType;
	@tracked errorText = '';

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.dataExportDelivery = data.dataExportDelivery;
	}

	override get classes(): string {
		return super.classes + ' ' + this.status;
	}

	get isLoading() {
		return this.status === GeneralType.LOADING;
	}

	get isError() {
		return this.status === GeneralType.ERROR;
	}

	setError(errorText = '') {
		this.status = GeneralType.ERROR;
		this.errorText = errorText || 'Unknown error';
		this.expire(EXPIRE_ERROR);
	}

	setDone(sentDataExportDelivery: DataExportDeliveryLikeType) {
		this.status = GeneralType.OK;
		this.dataExportDelivery = sentDataExportDelivery;
		this.expire(null); // don't expire
	}

	checkIfDuplicated(items: InfolayerItemBase[]): boolean {
		return items.some(
			(item) =>
				item instanceof InfolayerItemDataExport &&
				item.errorText === this.errorText &&
				this.isError,
		);
	}
}
